import { bodySmall, resetAnchor } from '@payflip/ui';
import { Link as RouterLink } from 'react-router';
import styled from 'styled-components';
import { Badge as DesktopBadge } from '../nav/styled';

export const Wrapper = styled.div`
  height: 60px;
  width: 100%;
  background-color: ${({ theme }): string => theme.palette_white};
  border-top-color: ${({ theme }): string => theme.palette_gray_0};
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  z-index: 100;
`;

export const Link = styled(RouterLink)<{ selected: boolean }>`
  ${resetAnchor}
  ${bodySmall}

  flex: 1;
  max-width: 84px;
  box-sizing: border-box;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_blue_100 : theme.palette_gray_60};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: color 250ms ease;
  height: 100%;
  padding: 0 ${({ theme }): string => theme.spacing_unit_x1};
`;

export const IconWrapper = styled.div<{ selected: boolean }>`
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_blue_5 : 'transparent'};
  transition:
    background-color 250ms ease,
    color 250ms ease;
  position: relative;

  & > svg {
    height: 1rem;
  }
`;

export const Badge = styled(DesktopBadge)`
  top: 0px;
  right: 0px;
`;
